import UserRepository from "@domain/repositories/UserRepository";
import UseCase from "@domain/UseCase";
import { ImageFile } from "@domain/models/ImageFile";
import { User } from "@domain/models/User";

type Input = {
  userId: User["id"];
  data: Partial<User>;
  userImage?: ImageFile;
};

type Output = Promise<User>;

export class UpdateUserUseCase implements UseCase<Input, Output> {
  constructor(private readonly userRepository: UserRepository) {}

  execute({ userId, data, userImage }: Input) {
    return this.userRepository.update(userId, data, userImage);
  }
}
